export const CallStatus = {
  0: 'none',
  1: 'calling',
  2: 'ended',
  none: 0,
  calling: 1,
  ended: 2,
};
